import React, { useEffect, useState } from 'react'
import { NavLink } from "react-router-dom";
import Navbar from '../../components/Navbar';
import Nav from '../../components/Nav';
import Footer from '../../components/Footer';

const Jade_Global_Case_Study = () => {
    const [showExtraLinks, setShowExtraLinks] = useState(false);

    const handleMouseEnter = () => {
        setShowExtraLinks(true);
    };

    const handleMouseLeave = () => {
        setShowExtraLinks(false);
    };
    useEffect(() => {
        document.title = "Virtuos | Customer CLM Success Story for Leading IT Service Company";

    }, []);
    return (
        <div className='client-detail-page landing-page'>
            <div className='canvas'>
                <Navbar />
                <main className="main-wrapper">
                    <section className="main-blogs case-study">
                        <div className="article-wrapper">
                            <figure className="article-image">
                                <img
                                    src={`/img/jade-global-header-img.jpg`}
                                    alt="Jade Global"
                                />
                            </figure>
                            <div className="page-wrap article-info">
                                <span className="c-logo">
                                    <img
                                        src={`/img/jade-global-logo.png`}
                                        alt="Jade Global Logo"
                                    />
                                </span>
                                <div className="col-9 title-wrapper">
                                    <h2 className="article-heading">
                                        Jade Global embraces Agiloft CLM implemented by Virtuos
                                    </h2>
                                </div>
                            </div>
                        </div>
                        <section className="breadcrumb-kanaban">
                            <div className="page-wrap breadcrumb-wrapper">
                                <ul className="row main-breadcrumbs" id="main-breadcrumbs">
                                    <li>
                                        <NavLink to={`/corporate/`}>About Virtuos</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to={`/customers/`} className="active">
                                            Customer Success
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink
                                            to={`/customers#success-stories`}
                                            className="smooth"
                                        >
                                            CUSTOMER SUCCESS STORIES
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink to={`/succeedant/`} className="smooth">
                                            SUCCEEDANT CSM
                                        </NavLink>
                                    </li>

                                </ul>
                                <ul className="more-hidden-tabs">
                                    <li
                                        className={`more-btn ${showExtraLinks ? 'active' : ''} inline-flex items-center bg-gray-100 rounded px-4 py-2 cursor-pointer transition duration-300`}
                                        onMouseEnter={handleMouseEnter}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <i className="fal fa-plus" />  More
                                        {showExtraLinks && (
                                            <ul className="extra-links absolute top-full left-0 bg-white rounded shadow-lg p-1 w-full">
                                                <li>
                                                    <NavLink to={`/corporate/experience-edge/`}>
                                                        EXPERIENCE EDGE
                                                    </NavLink>
                                                </li>
                                                <li>
                                                    <NavLink to={`/insights/`}>
                                                        INSIGHTS AND RESOURCES
                                                    </NavLink>
                                                </li>
                                            </ul>
                                        )}
                                    </li>
                                </ul>
                            </div>
                        </section>
                        <div className="page-wrap row">
                            <div className="col-10 article-content">
                                <h3 className="title">About Jade Global</h3>
                                <p>
                                    Jade is a trusted IT services partner for global enterprises to
                                    accelerate their digital transformation journey. Jade function as a
                                    trusted advisors to help them make the right technology decisions.
                                </p>
                                <p>
                                    Jade services include business application implementations,
                                    integrations, software product engineering, cloud services, technology
                                    advisory, testing, and managed services. They have domain expertise in
                                    a variety of industries including manufacturing, high-tech, energy,
                                    pharmaceuticals, and warehouse distribution.
                                </p>
                                <h3 className="title">Challenges</h3>
                                <ul>
                                    <li>
                                        No inter department harmonization, due to which approvals were time
                                        consuming.
                                    </li>
                                    <li>Unable to maintain track of correct contract version.</li>
                                    <li>No defined SLA and TAT for stakeholders.</li>
                                    <li>Minimum visibility of contract's status to management.</li>
                                    <li>No central repository for documents.</li>
                                    <li>Unable to synchronise the CRM with Manual Process</li>
                                </ul>
                                <h3 className="title">Need</h3>
                                <ul>
                                    <li>
                                        Need to integrate contracts with CRM (Initiation point for
                                        Contracts).
                                    </li>
                                    <li>Streamlined processes between Sales and Legal.</li>
                                    <li>Clarity for Sales and Legal on the progress of a Contract.</li>
                                    <li>Automating approval workflow based on type of contracts.</li>
                                    <li>Adhering to defines SLA and TAT for each team.</li>
                                    <li>Capture approval history.</li>
                                    <li>Dashboard for Business heads for insights on contracts.</li>
                                    <li>Standardizing Contract Templates.</li>
                                </ul>
                                <h3 className="title">Win</h3>
                                <ul>
                                    <li>
                                        Integration of Salesforce with Agiloft via Dell Boomi. Provided
                                        teams to stay on top of the contract progress and take next best
                                        action.
                                    </li>
                                    <li>Contract Synchronization between Salesforce and Agiloft.</li>
                                    <li>
                                        Automation of approval workflow based on contract type. Capturing
                                        Approval history for all contracts.
                                    </li>
                                    <li>
                                        Clear representation of active contracts and expired contracts.
                                        On-time notifications for renewal.
                                    </li>
                                    <li>
                                        Rich Data insight with dashboard for all management personnel.
                                    </li>
                                    <li>
                                        Reduced the count of missed renewal and contracts requiring
                                        immediate attention/action.
                                    </li>
                                    <li>
                                        Integration with Outlook and MS Word to minimize Legal's effort for
                                        contract creation.
                                    </li>
                                    <li>
                                        Improved tracking of clauses and version control of contracts.
                                    </li>
                                </ul>
                                <h3 className="title">Partner</h3>
                                <p>
                                    Virtuos is a Gold Partner for Agiloft, has rich experience in
                                    implementing complex solutions and our team has delivered and
                                    surpassed customer's expectations always.
                                </p>
                            </div>
                        </div>
                    </section>
                    <section className="customer-success-section">
                        <h2 className="section-main-heading">
                            Other <span className="highlight">Case Studies</span>
                        </h2>
                        <div className="clients-wrapper">
                            <ul className="row page-wrap offport-down">
                                <li className="col-3">
                                    <NavLink
                                        to={`/customers/standard-chartered-case-study`}
                                        className="item"
                                    >
                                        <figure>
                                            <img
                                                src={`/img/standard-chartered-casestudy-img.jpg`}
                                                alt="Standard Chartered Casestudy"
                                            />
                                        </figure>
                                        <span className="c-logo">
                                            <img
                                                src={`/img/svg/standard_chartered.svg`}
                                                alt="Standard Chartered Bank Logo"
                                            />
                                        </span>
                                    </NavLink>
                                    <div className="item-wrapper">
                                        <p className="title">CX and Contact Center Automation</p>
                                    </div>
                                </li>
                                <li className="col-3">
                                    <NavLink
                                        to={`/customers/tvs-credit-case-study`}
                                        className="item"
                                    >
                                        <figure>
                                            <img
                                                src={`/img/tvsc-casestudy-img.jpg`}
                                                alt="TVS Credit Case Study"
                                            />
                                        </figure>
                                        <span className="c-logo">
                                            <img
                                                src={`/img/tvscs-logo.png`}
                                                alt="TVS Credit"
                                            />
                                        </span>
                                    </NavLink>
                                    <div className="item-wrapper">
                                        <p className="title">
                                            Customer Experience Transformation Project using Oracle platform
                                        </p>
                                    </div>
                                </li>
                                <li className="col-3">
                                    <NavLink
                                        to={`/customers/makemytrip-case-study`}
                                        className="item"
                                    >
                                        <figure>
                                            <img
                                                src={`/img/makemytrip-casestudy-img.jpg`}
                                                alt="Make My Trip Casestudy"
                                            />
                                        </figure>
                                        <span className="c-logo">
                                            <img
                                                src={`/img/svg/make-my-trip-logo.svg`}
                                                alt="Make My Trip Logo"
                                            />
                                        </span>
                                    </NavLink>
                                    <div className="item-wrapper">
                                        <p className="title">
                                            MakeMyTrip.com halved avg. call handling time and increased
                                            revenue with CX Cloud
                                        </p>
                                    </div>
                                </li>
                                <li className="col-3">
                                    <NavLink
                                        to={`/customers/electronics-company-case-study`}
                                        className="item"
                                    >
                                        <figure>
                                            <img
                                                src={`/img/electronics-company-casestudy-img.jpg`}
                                                alt="Electronics Company Case Study"
                                            />
                                        </figure>
                                        <span className="c-logo">
                                            <img
                                                src={`/img/svg/confidential-logo.svg`}
                                                alt="Confidential Logo"
                                            />
                                        </span>
                                    </NavLink>
                                    <div className="item-wrapper">
                                        <p className="title">
                                            Customer engagement on phone, email, chat and social channels
                                        </p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </section>
                    <Footer />
                </main>

            </div>
            <div className='off-canvas'>
                <Nav />
            </div>
        </div>
    )
}

export default Jade_Global_Case_Study